<template>
  <div class="d-flex justify-content-between align-items-center mt-2">
    <div>
      <button type="button" class="btn btn-sm btn-secondary me-2" :disabled="page <= 1 || loading"
        @click="$emit('prev')">Anterior</button>
      <button type="button" class="btn btn-sm btn-secondary" :disabled="page >= totalPages || loading"
        @click="$emit('next')">Siguiente</button>
    </div>
    <div>
      <small>Total de registros: {{ format(totalItems) }}</small>
    </div>
    <div>
      <small>Página {{ page }} de {{ format(totalPages) }}</small>
    </div>
  </div>
</template>

<script>
// Pie de paginación por servidor (Anterior/Siguiente, total y página) para los catálogos
// grandes: ver specs/004-fix-listados-paginados.
export default {
  name: 'ServerPager',
  props: {
    page: { type: Number, default: 1 },
    totalPages: { type: Number, default: 1 },
    totalItems: { type: Number, default: 0 },
    loading: { type: Boolean, default: false },
  },
  emits: ['prev', 'next'],
  methods: {
    format(value) {
      return (Number(value) || 0).toLocaleString('en-US');
    },
  },
};
</script>
